/*
Hard code or grab from .env file any environment-specific config options
 */

const BASE_URL = {
  local: {
    device: 'https://func-fuji-dev-cus-dvc.azurewebsites.net/api',
    organization: 'https://func-fuji-dev-cus-org.azurewebsites.net/api',
    authService: `http://localhost:3000`,
    alertService: `https://func-fuji-dev-cus-alrt.azurewebsites.net/api`,
    userService: `https://func-fuji-dev-cus-usr.azurewebsites.net/api`,    
    apimOrganizationUrl: 'https://func-fuji-dev-cus-org.azurewebsites.net/api',
  },
  dev: {
    device: 'https://flashcast-eng.mimomonitors.com/api/device',
    organization: 'https://flashcast-eng.mimomonitors.com/api/org',
    authService: `https://flashcast-eng.mimomonitors.com/api/auth`,
    alertService: `https://flashcast-eng.mimomonitors.com/api/alerts`,
    userService: `https://flashcast-eng.mimomonitors.com/api/users`,
    apimOrganizationUrl: 'https://apim-fuji-dev-cus-001.azure-api.net/api/org',
  },
  prod: {
    device: 'https://flashcast.mimomonitors.com/api/device',
    organization: 'https://flashcast.mimomonitors.com/api/org',
    authService: 'https://flashcast.mimomonitors.com/api/auth',
    alertService: 'https://flashcast.mimomonitors.com/api/alerts',
    userService: 'https://flashcast.mimomonitors.com/api/users',
    apimOrganizationUrl: 'https://apim-fuji-prod-cus-001.azure-api.net/api/org',
  },
};

const LOCAL = {
  envDisplay: 'Local',
  signInUrl: `${BASE_URL.local.authService}/firebaseAuth/signin`,
  signOutUrl: `${BASE_URL.local.authService}/firebaseAuth/signout`,
  acquireTokenUrl: `${BASE_URL.local.authService}/auth/acquireRefreshedToken`,
  sendResetPasswordEmail: `${BASE_URL.local.authService}/users/sendResetPasswordEmail`,
  resetPassword: `${BASE_URL.local.authService}/users/resetPassword`,
  deleteOrgUrl: `${BASE_URL.local.organization}/deleteGroup`,
  listDevicesUrl: `${BASE_URL.local.device}/listDevices`,
  addDevicesUrl: `${BASE_URL.local.device}/addDevice`,
  deleteDeviceUrl: `${BASE_URL.local.device}/deleteDevice`,
  pendingDeletionsUrl: `${BASE_URL.local.device}/pendingDeletions`,
  forceDeleteDeviceUrl: `${BASE_URL.local.device}/forceDeleteDevice`,
  updateDeviceUrl: `${BASE_URL.local.device}/updateDevice`,
  unassignDeviceUrl: `${BASE_URL.local.device}/unassignDevice`,
  assignDevicesUrl: `${BASE_URL.local.device}/assignDevices`,
  createGroupUrl: `${BASE_URL.local.organization}/creategroup`,
  editGroupUrl: `${BASE_URL.local.organization}/updategroup`,
  sendEmailUrl: `${BASE_URL.local.organization}/sendEmail`,
  verifyEmailAddressUrl: `${BASE_URL.local.organization}/verifyEmailAddress`,
  registerOrgUrl: `${BASE_URL.local.organization}/registerOrganisation`,
  generatePublicApiTokenUrl: `${BASE_URL.local.organization}/generatePublicApiToken`,
  listGroupsUrl: `${BASE_URL.local.organization}/listgroups`,
  listPublicApiTokensUrl:`${BASE_URL.local.organization}/listPublicApiTokens`,
  revokePublicApiTokenUrl:`${BASE_URL.local.organization}/revokePublicApiToken`,
  getPublicApiApprovalStatusUrl:`${BASE_URL.local.organization}/getPublicApiApprovalStatus`,
  getLicensesUrl: `${BASE_URL.local.organization}/getLicenses`,
  addOrManageMobileLicenseUrl: `${BASE_URL.local.organization}/addOrManageMobileLicensingAccess`,
  revokeMobileLicenseUrl: `${BASE_URL.local.organization}/revokeMobileLicense`,
  listOrganizationsUrl: `${BASE_URL.local.organization}/listOrganisations`,
  getOrgTemplatesUrl: `${BASE_URL.local.organization}/getOrgTemplates`,
  putOrgTemplatesUrl: `${BASE_URL.local.organization}/putOrgTemplates`,
  getTemplatesUrl: `${BASE_URL.local.organization}/getTemplates`,
  addTemplateUrl: `${BASE_URL.local.organization}/addTemplate`,
  updateTemplateUrl: `${BASE_URL.local.organization}/updateTemplate`,
  deleteOrganizationUrl: `${BASE_URL.local.organization}/deleteOrganization`,
  updateOrganizationUrl: `${BASE_URL.local.organization}/updateOrganisation`,
  updateOrgStatusUrl: `${BASE_URL.local.organization}/updateOrganisationStatus`,
  generateDeviceReportUrl: `${BASE_URL.local.organization}/generateDeviceUpdateReport`,
  listAlertsUrl: `${BASE_URL.local.alertService}/listAlerts`,
  deleteAlertUrl: `${BASE_URL.local.alertService}/deleteAlert`,
  listUserUrl: `${BASE_URL.local.userService}/listUsers`,
  deleteUserUrl: `${BASE_URL.local.userService}/deleteUser`,
  updateUserUrl: `${BASE_URL.local.userService}/updateUser`,
  createUserUrl: `${BASE_URL.local.userService}/createUser`,
  inviteUserUrl: `${BASE_URL.local.userService}/inviteUser`,
  getMobileLicenseUsersUrl: `${BASE_URL.local.userService}/getMobileLicenseUsers`,
  manageMobileLicenseUsersUrl: `${BASE_URL.local.userService}/manageMobileLicenseUsers`,
  verifyUserInvitationTokenUrl: `${BASE_URL.local.userService}/verifyUserInvitationToken`,
  createAlertUrl: `${BASE_URL.local.alertService}/createAlert`,
  editAlertUrl: `${BASE_URL.local.alertService}/editAlert`,
  listAlerTypestUrl: `${BASE_URL.local.alertService}/getAlertTypes`,
  createDASAlertUrl: `${BASE_URL.local.alertService}/createSubscription`,
  sendDASAlertUrl: `${BASE_URL.local.alertService}/createDasAlert`,
  endAlertUrl: `${BASE_URL.local.alertService}/endAlert`,
  listApprovalAlertUrl: `${BASE_URL.local.alertService}/listApprovalAlerts`,
  approveAlertUrl: `${BASE_URL.local.alertService}/approveAlerts`,
  denyAlertUrl: `${BASE_URL.local.alertService}/denyAlerts`,
  resendAlertUrl: `${BASE_URL.local.alertService}/resendAlert`,
  listDasSubscriptionsUrl: `${BASE_URL.local.alertService}/listSubscriptions`,
  deleteSubscriptionsUrl: `${BASE_URL.local.alertService}/deleteSubscription`,
  editSubscriptionUrl: `${BASE_URL.local.alertService}/editSubscription`,
  dashboardDetailsUrl: `${BASE_URL.local.device}/getDashboardDetails`,
  alertActionUrl: `${BASE_URL.local.alertService}/alertAction`,
  listFirmwaresUrl: `${BASE_URL.local.device}/listFirmwares`,
  listIotAgentUrl: `${BASE_URL.local.device}/listIotAgents`,
  uploadFirmwareUrl: `${BASE_URL.local.device}/firmwareBlob`,
  deleteFirmwareBlobUrl: `${BASE_URL.local.device}/deleteFirmwareBlob`,
  deleteIotAgentBlobUrl: `${BASE_URL.local.device}/deleteIotAgentBlob`,
  uploadIotAgentUrl: `${BASE_URL.local.device}/iotAgentBlob`,
  deviceLogUrl: `${BASE_URL.local.device}/getDeviceLogs`,
  updateOrganizationExecutablesUrl: `${BASE_URL.local.organization}/updateDeviceExecutables`,
  configureSinglewireTokenUrl: `${BASE_URL.local.alertService}/configureSinglewireToken`,
  singlewireWebhookURL: `${BASE_URL.local.alertService}/createSinglewireAlerts`,
  listSinglewireSiteUrl: `${BASE_URL.local.alertService}/getSingleWireSites?`,
  mapSinglewireSitesUrl: `${BASE_URL.local.alertService}/mapSinglewireSites?`,
  mapEverbridgeGroupsUrl: `${BASE_URL.local.alertService}/mapEverbridgeGroups?`,
  configureEverbridgeTokenUrl: `${BASE_URL.local.alertService}/configureEverbridgeToken`,
  listEverbridgeGroupUrl: `${BASE_URL.local.alertService}/getEverbridgeGroups?`,
  getIntegrationWebhookStatusUrl: `${BASE_URL.local.alertService}/getIntegrationWebhookStatus?`,
  everbridgeWebhookURL: `${BASE_URL.local.alertService}/createEverbridgeAlerts`,
  alertusWebhookURL: `${BASE_URL.local.alertService}/createAlertusAlert`,
  generateAlertusTokenUrl: `${BASE_URL.local.organization}/generateAlertusToken`,
  listAlertusTokensUrl: `${BASE_URL.local.organization}/listAlertusTokens`,
  revokeAlertusTokenUrl: `${BASE_URL.local.organization}/revokeAlertusToken`,
  quickAlertsUrl: `${BASE_URL.local.alertService}/quickAlerts`,
  listQuickAlertsUrl: `${BASE_URL.local.alertService}/listQuickAlerts`,
  createQuickAlertsUrl: `${BASE_URL.local.alertService}/createQuickAlerts`,
  editQuickAlertsUrl: `${BASE_URL.local.alertService}/editQuickAlert`,
  deleteQuickAlertsUrl: `${BASE_URL.local.alertService}/deleteQuickAlert`,
  sendQuickAlertsUrl: `${BASE_URL.local.alertService}/sendQuickAlerts`,
  saveQuickAlertsOrderUrl: `${BASE_URL.local.alertService}/saveQuickAlertsOrder`,
  approvePublicApiUserUrl: `${BASE_URL.local.organization}/approvePublicApiUser`,
  createCapEndpointUrl: `${BASE_URL.local.alertService}/createCapEndpoint`,
  listCapEndpointsUrl: `${BASE_URL.local.alertService}/listCapEndpoints`,
  updateCapEndpointUrl: `${BASE_URL.local.alertService}/updateCapEndpoint`,
  deleteCapEndpointUrl: `${BASE_URL.local.alertService}/deleteCapEndpoint`,
  regenerateCapEndpointTokenUrl: `${BASE_URL.local.alertService}/regenerateCapEndpointToken`,
  capWebhookURL: `${BASE_URL.local.alertService}/cap/post?endpoint=`,
  rebootDeviceUrl: `${BASE_URL.local.device}/rebootDevice`,
  getOrganizationsAnalyticsUrl: `${BASE_URL.local.organization}/getOrganizationsAnalytics`,
  getSuperAdminDeviceAnalyticsUrl: `${BASE_URL.local.device}/getSuperAdminDeviceAnalytics`,
  getThirdPartyIntegrationStatsUrl: `${BASE_URL.local.alertService}/getThirdPartyIntegrationAdoptionStats`,
  getWebhookMigrationConfigUrl: `${BASE_URL.local.alertService}/getWebhookMigrationConfig`,
  updateWebhookMigrationConfigUrl: `${BASE_URL.local.alertService}/updateWebhookMigrationConfig`,
  triggerWebhookUrlUpdateReminderUrl: `${BASE_URL.local.alertService}/triggerWebhookUrlUpdateReminder`,
  getAlertsStatsUrl: `${BASE_URL.local.alertService}/getAlertsStats`,
  getVersionDistributionUrl: `${BASE_URL.local.device}/getVersionDistribution`,
  getUserCountAndDetailsUrl: `${BASE_URL.local.userService}/getUserCountAndDetails`,
  getAlertDetailsUrl: `${BASE_URL.local.alertService}/getAlertDetails`,
  getHelpGuidesUrl: `${BASE_URL.local.organization}/getHelpGuides`,
  addHelpGuideUrl: `${BASE_URL.local.apimOrganizationUrl}/addHelpGuide`,
  editHelpGuideUrl: `${BASE_URL.local.apimOrganizationUrl}/editHelpGuide`,
  deleteHelpGuideUrl: `${BASE_URL.local.organization}/deleteHelpGuide`,
  firebaseConfig: {
    apiKey: "AIzaSyBLpE8z8bKkLpLv1evr1929YGaQo_gSj7E",
    authDomain: "flashcast-dev.firebaseapp.com",
    projectId: "flashcast-dev",
    storageBucket: "flashcast-dev.firebasestorage.app",
    messagingSenderId: "793693959355",
    appId: "1:793693959355:web:bf94f320beaca79e18659e",
  },
  roleIds: {
    superAdmin: 'ca310b8d-2f4a-44e0-a36e-957c202cd8d4',
    admin: 'c495eb57-eb18-489e-9802-62c474e5645c',
    operator: 'b4935647-30e4-4ed3-9074-dcac66c2f8ef',
    viewer: '84cc62c1-dabe-49d3-b16e-8b291232b285',
  },
  apimSubscriptionKey: '83741bacdc8c46809b0815ac32f4db3c',
};

const DEV = {
  envDisplay: 'Development',
  signInUrl: `${BASE_URL.dev.authService}/firebaseAuth/signin`,
  signOutUrl: `${BASE_URL.dev.authService}/firebaseAuth/signout`,
  acquireTokenUrl: `${BASE_URL.dev.authService}/auth/acquireRefreshedToken`,
  sendResetPasswordEmail: `${BASE_URL.dev.authService}/users/sendResetPasswordEmail`,
  resetPassword: `${BASE_URL.dev.authService}/users/resetPassword`,
  deleteOrgUrl: `${BASE_URL.dev.organization}/deleteGroup`,
  listDevicesUrl: `${BASE_URL.dev.device}/listDevices`,
  addDevicesUrl: `${BASE_URL.dev.device}/addDevice`,
  deleteDeviceUrl: `${BASE_URL.dev.device}/deleteDevice`,
  pendingDeletionsUrl: `${BASE_URL.dev.device}/pendingDeletions`,
  forceDeleteDeviceUrl: `${BASE_URL.dev.device}/forceDeleteDevice`,
  updateDeviceUrl: `${BASE_URL.dev.device}/updateDevice`,
  unassignDeviceUrl: `${BASE_URL.dev.device}/unassignDevice`,
  assignDevicesUrl: `${BASE_URL.dev.device}/assignDevices`,
  createGroupUrl: `${BASE_URL.dev.organization}/creategroup`,
  editGroupUrl: `${BASE_URL.dev.organization}/updategroup`,
  sendEmailUrl: `${BASE_URL.dev.organization}/sendEmail`,
  verifyEmailAddressUrl: `${BASE_URL.dev.organization}/verifyEmailAddress`,
  registerOrgUrl: `${BASE_URL.dev.organization}/registerOrganisation`,
  generatePublicApiTokenUrl: `${BASE_URL.dev.organization}/generatePublicApiToken`,
  listGroupsUrl: `${BASE_URL.dev.organization}/listgroups`,
  listPublicApiTokensUrl:`${BASE_URL.dev.organization}/listPublicApiTokens`,
  revokePublicApiTokenUrl:`${BASE_URL.dev.organization}/revokePublicApiToken`,
  getPublicApiApprovalStatusUrl:`${BASE_URL.dev.organization}/getPublicApiApprovalStatus`,
  getLicensesUrl: `${BASE_URL.dev.organization}/getLicenses`,
  addOrManageMobileLicenseUrl: `${BASE_URL.dev.organization}/addOrManageMobileLicensingAccess`,
  revokeMobileLicenseUrl: `${BASE_URL.dev.organization}/revokeMobileLicense`,
  listOrganizationsUrl: `${BASE_URL.dev.organization}/listOrganisations`,
  getOrgTemplatesUrl: `${BASE_URL.dev.organization}/getOrgTemplates`,
  putOrgTemplatesUrl: `${BASE_URL.dev.organization}/putOrgTemplates`,
  getTemplatesUrl: `${BASE_URL.dev.organization}/getTemplates`,
  addTemplateUrl: `${BASE_URL.dev.organization}/addTemplate`,
  updateTemplateUrl: `${BASE_URL.dev.organization}/updateTemplate`,
  deleteOrganizationUrl: `${BASE_URL.dev.organization}/deleteOrganization`,
  updateOrganizationUrl: `${BASE_URL.dev.organization}/updateOrganisation`,
  updateOrgStatusUrl: `${BASE_URL.dev.organization}/updateOrganisationStatus`,
  generateDeviceReportUrl: `${BASE_URL.dev.organization}/generateDeviceUpdateReport`,
  listAlertsUrl: `${BASE_URL.dev.alertService}/listAlerts`,
  deleteAlertUrl: `${BASE_URL.dev.alertService}/deleteAlert`,
  listUserUrl: `${BASE_URL.dev.userService}/listUsers`,
  deleteUserUrl: `${BASE_URL.dev.userService}/deleteUser`,
  updateUserUrl: `${BASE_URL.dev.userService}/updateUser`,
  createUserUrl: `${BASE_URL.dev.userService}/createUser`,
  inviteUserUrl: `${BASE_URL.dev.userService}/inviteUser`,
  getMobileLicenseUsersUrl: `${BASE_URL.dev.userService}/getMobileLicenseUsers`,
  manageMobileLicenseUsersUrl: `${BASE_URL.dev.userService}/manageMobileLicenseUsers`,
  verifyUserInvitationTokenUrl: `${BASE_URL.dev.userService}/verifyUserInvitationToken`,
  createAlertUrl: `${BASE_URL.dev.alertService}/createAlert`,
  endAlertUrl: `${BASE_URL.dev.alertService}/endAlert`,
  editAlertUrl: `${BASE_URL.dev.alertService}/editAlert`,
  listApprovalAlertUrl: `${BASE_URL.dev.alertService}/listApprovalAlerts`,
  approveAlertUrl: `${BASE_URL.dev.alertService}/approveAlerts`,
  denyAlertUrl: `${BASE_URL.dev.alertService}/denyAlerts`,
  resendAlertUrl: `${BASE_URL.dev.alertService}/resendAlert`,
  listAlerTypestUrl: `${BASE_URL.dev.alertService}/getAlertTypes`,
  createDASAlertUrl: `${BASE_URL.dev.alertService}/createSubscription`,
  sendDASAlertUrl: `${BASE_URL.dev.alertService}/createDasAlert`,
  listDasSubscriptionsUrl: `${BASE_URL.dev.alertService}/listSubscriptions`,
  deleteSubscriptionsUrl: `${BASE_URL.dev.alertService}/deleteSubscription`,
  editSubscriptionUrl: `${BASE_URL.dev.alertService}/editSubscription`,
  dashboardDetailsUrl: `${BASE_URL.dev.device}/getDashboardDetails`,
  alertActionUrl: `${BASE_URL.dev.alertService}/alertAction`,
  listFirmwaresUrl: `${BASE_URL.dev.device}/listFirmwares`,
  listIotAgentUrl: `${BASE_URL.dev.device}/listIotAgents`,
  uploadFirmwareUrl: `${BASE_URL.dev.device}/firmwareBlob`,
  deleteFirmwareBlobUrl: `${BASE_URL.dev.device}/deleteFirmwareBlob`,
  deleteIotAgentBlobUrl: `${BASE_URL.dev.device}/deleteIotAgentBlob`,
  uploadIotAgentUrl: `${BASE_URL.dev.device}/iotAgentBlob`,
  deviceLogUrl: `${BASE_URL.dev.device}/getDeviceLogs`,
  updateOrganizationExecutablesUrl: `${BASE_URL.dev.organization}/updateDeviceExecutables`,
  configureSinglewireTokenUrl: `${BASE_URL.dev.alertService}/configureSinglewireToken`,
  singlewireWebhookURL: `${BASE_URL.dev.alertService}/createSinglewireAlerts`,
  listSinglewireSiteUrl: `${BASE_URL.dev.alertService}/getSingleWireSites?`,
  mapSinglewireSitesUrl: `${BASE_URL.dev.alertService}/mapSinglewireSites?`,
  mapEverbridgeGroupsUrl: `${BASE_URL.dev.alertService}/mapEverbridgeGroups?`,
  configureEverbridgeTokenUrl: `${BASE_URL.dev.alertService}/configureEverbridgeToken`,
  listEverbridgeGroupUrl: `${BASE_URL.dev.alertService}/getEverbridgeGroups?`,
  getIntegrationWebhookStatusUrl: `${BASE_URL.dev.alertService}/getIntegrationWebhookStatus?`,
  everbridgeWebhookURL: `${BASE_URL.dev.alertService}/createEverbridgeAlerts`,
  alertusWebhookURL: `${BASE_URL.dev.alertService}/createAlertusAlert`,
  generateAlertusTokenUrl: `${BASE_URL.dev.organization}/generateAlertusToken`,
  listAlertusTokensUrl: `${BASE_URL.dev.organization}/listAlertusTokens`,
  revokeAlertusTokenUrl: `${BASE_URL.dev.organization}/revokeAlertusToken`,
  quickAlertsUrl: `${BASE_URL.dev.alertService}/quickAlerts`,
  listQuickAlertsUrl: `${BASE_URL.dev.alertService}/listQuickAlerts`,
  createQuickAlertsUrl: `${BASE_URL.dev.alertService}/createQuickAlerts`,
  editQuickAlertsUrl: `${BASE_URL.dev.alertService}/editQuickAlert`,
  deleteQuickAlertsUrl: `${BASE_URL.dev.alertService}/deleteQuickAlert`,
  sendQuickAlertsUrl: `${BASE_URL.dev.alertService}/sendQuickAlerts`,
  saveQuickAlertsOrderUrl: `${BASE_URL.dev.alertService}/saveQuickAlertsOrder`,
  approvePublicApiUserUrl: `${BASE_URL.dev.organization}/approvePublicApiUser`,
  createCapEndpointUrl: `${BASE_URL.dev.alertService}/createCapEndpoint`,
  listCapEndpointsUrl: `${BASE_URL.dev.alertService}/listCapEndpoints`,
  updateCapEndpointUrl: `${BASE_URL.dev.alertService}/updateCapEndpoint`,
  deleteCapEndpointUrl: `${BASE_URL.dev.alertService}/deleteCapEndpoint`,
  regenerateCapEndpointTokenUrl: `${BASE_URL.dev.alertService}/regenerateCapEndpointToken`,
  capWebhookURL: `${BASE_URL.dev.alertService}/cap/post?endpoint=`,
  rebootDeviceUrl: `${BASE_URL.dev.device}/rebootDevice`,
  getOrganizationsAnalyticsUrl: `${BASE_URL.dev.organization}/getOrganizationsAnalytics`,
  getSuperAdminDeviceAnalyticsUrl: `${BASE_URL.dev.device}/getSuperAdminDeviceAnalytics`,
  getThirdPartyIntegrationStatsUrl: `${BASE_URL.dev.alertService}/getThirdPartyIntegrationAdoptionStats`,
  getWebhookMigrationConfigUrl: `${BASE_URL.dev.alertService}/getWebhookMigrationConfig`,
  updateWebhookMigrationConfigUrl: `${BASE_URL.dev.alertService}/updateWebhookMigrationConfig`,
  triggerWebhookUrlUpdateReminderUrl: `${BASE_URL.dev.alertService}/triggerWebhookUrlUpdateReminder`,
  getAlertsStatsUrl: `${BASE_URL.dev.alertService}/getAlertsStats`,
  getVersionDistributionUrl: `${BASE_URL.dev.device}/getVersionDistribution`,
  getUserCountAndDetailsUrl: `${BASE_URL.dev.userService}/getUserCountAndDetails`,
  getAlertDetailsUrl: `${BASE_URL.dev.alertService}/getAlertDetails`,
  getHelpGuidesUrl: `${BASE_URL.dev.organization}/getHelpGuides`,
  addHelpGuideUrl: `${BASE_URL.dev.apimOrganizationUrl}/addHelpGuide`,
  editHelpGuideUrl: `${BASE_URL.dev.apimOrganizationUrl}/editHelpGuide`,
  deleteHelpGuideUrl: `${BASE_URL.dev.organization}/deleteHelpGuide`,
  firebaseConfig: {
    apiKey: "AIzaSyBLpE8z8bKkLpLv1evr1929YGaQo_gSj7E",
    authDomain: "flashcast-dev.firebaseapp.com",
    projectId: "flashcast-dev",
    storageBucket: "flashcast-dev.firebasestorage.app",
    messagingSenderId: "793693959355",
    appId: "1:793693959355:web:bf94f320beaca79e18659e",
  },
  roleIds: {
    superAdmin: 'ca310b8d-2f4a-44e0-a36e-957c202cd8d4',
    admin: 'c495eb57-eb18-489e-9802-62c474e5645c',
    operator: 'b4935647-30e4-4ed3-9074-dcac66c2f8ef',
    viewer: '84cc62c1-dabe-49d3-b16e-8b291232b285',
  },
  apimSubscriptionKey: '83741bacdc8c46809b0815ac32f4db3c',
};

const PRODUCTION = {
  envDisplay: 'Production',
  signInUrl: `${BASE_URL.prod.authService}/firebaseAuth/signin`,
  signOutUrl: `${BASE_URL.prod.authService}/firebaseAuth/signout`,
  acquireTokenUrl: `${BASE_URL.prod.authService}/auth/acquireRefreshedToken`,
  sendResetPasswordEmail: `${BASE_URL.prod.authService}/users/sendResetPasswordEmail`,
  resetPassword: `${BASE_URL.prod.authService}/users/resetPassword`,
  deleteOrgUrl: `${BASE_URL.prod.organization}/deleteGroup`,
  listDevicesUrl: `${BASE_URL.prod.device}/listDevices`,
  addDevicesUrl: `${BASE_URL.prod.device}/addDevice`,
  deleteDeviceUrl: `${BASE_URL.prod.device}/deleteDevice`,
  pendingDeletionsUrl: `${BASE_URL.prod.device}/pendingDeletions`,
  forceDeleteDeviceUrl: `${BASE_URL.prod.device}/forceDeleteDevice`,
  updateDeviceUrl: `${BASE_URL.prod.device}/updateDevice`,
  unassignDeviceUrl: `${BASE_URL.prod.device}/unassignDevice`,
  assignDevicesUrl: `${BASE_URL.prod.device}/assignDevices`,
  createGroupUrl: `${BASE_URL.prod.organization}/creategroup`,
  editGroupUrl: `${BASE_URL.prod.organization}/updategroup`,
  sendEmailUrl: `${BASE_URL.prod.organization}/sendEmail`,
  verifyEmailAddressUrl: `${BASE_URL.prod.organization}/verifyEmailAddress`,
  registerOrgUrl: `${BASE_URL.prod.organization}/registerOrganisation`,
  generatePublicApiTokenUrl: `${BASE_URL.prod.organization}/generatePublicApiToken`,
  listGroupsUrl: `${BASE_URL.prod.organization}/listgroups`,
  listPublicApiTokensUrl:`${BASE_URL.prod.organization}/listPublicApiTokens`,
  revokePublicApiTokenUrl:`${BASE_URL.prod.organization}/revokePublicApiToken`,
  getPublicApiApprovalStatusUrl:`${BASE_URL.prod.organization}/getPublicApiApprovalStatus`,
  getLicensesUrl: `${BASE_URL.prod.organization}/getLicenses`,
  addOrManageMobileLicenseUrl: `${BASE_URL.prod.organization}/addOrManageMobileLicensingAccess`,
  revokeMobileLicenseUrl: `${BASE_URL.prod.organization}/revokeMobileLicense`,
  revokeAccessTokenUrl: `${BASE_URL.prod.organization}/revokeMobileLicense`,
  listOrganizationsUrl: `${BASE_URL.prod.organization}/listOrganisations`,
  getOrgTemplatesUrl: `${BASE_URL.prod.organization}/getOrgTemplates`,
  putOrgTemplatesUrl: `${BASE_URL.prod.organization}/putOrgTemplates`,
  getTemplatesUrl: `${BASE_URL.prod.organization}/getTemplates`,
  addTemplateUrl: `${BASE_URL.prod.organization}/addTemplate`,
  updateTemplateUrl: `${BASE_URL.prod.organization}/updateTemplate`,
  deleteOrganizationUrl: `${BASE_URL.prod.organization}/deleteOrganization`,
  updateOrganizationUrl: `${BASE_URL.prod.organization}/updateOrganisation`,
  updateOrgStatusUrl: `${BASE_URL.prod.organization}/updateOrganisationStatus`,
  generateDeviceReportUrl: `${BASE_URL.prod.organization}/generateDeviceUpdateReport`,
  listAlertsUrl: `${BASE_URL.prod.alertService}/listAlerts`,
  deleteAlertUrl: `${BASE_URL.prod.alertService}/deleteAlert`,
  listUserUrl: `${BASE_URL.prod.userService}/listUsers`,
  deleteUserUrl: `${BASE_URL.prod.userService}/deleteUser`,
  updateUserUrl: `${BASE_URL.prod.userService}/updateUser`,
  createUserUrl: `${BASE_URL.prod.userService}/createUser`,
  inviteUserUrl: `${BASE_URL.prod.userService}/inviteUser`,
  getMobileLicenseUsersUrl: `${BASE_URL.prod.userService}/getMobileLicenseUsers`,
  manageMobileLicenseUsersUrl: `${BASE_URL.prod.userService}/manageMobileLicenseUsers`,
  verifyUserInvitationTokenUrl: `${BASE_URL.prod.userService}/verifyUserInvitationToken`,
  createAlertUrl: `${BASE_URL.prod.alertService}/createAlert`,
  endAlertUrl: `${BASE_URL.prod.alertService}/endAlert`,
  editAlertUrl: `${BASE_URL.prod.alertService}/editAlert`,
  listApprovalAlertUrl: `${BASE_URL.prod.alertService}/listApprovalAlerts`,
  approveAlertUrl: `${BASE_URL.prod.alertService}/approveAlerts`,
  denyAlertUrl: `${BASE_URL.prod.alertService}/denyAlerts`,
  resendAlertUrl: `${BASE_URL.prod.alertService}/resendAlert`,
  listAlerTypestUrl: `${BASE_URL.prod.alertService}/getAlertTypes`,
  createDASAlertUrl: `${BASE_URL.prod.alertService}/createSubscription`,
  sendDASAlertUrl: `${BASE_URL.prod.alertService}/createDasAlert`,
  listDasSubscriptionsUrl: `${BASE_URL.prod.alertService}/listSubscriptions`,
  deleteSubscriptionsUrl: `${BASE_URL.prod.alertService}/deleteSubscription`,
  editSubscriptionUrl: `${BASE_URL.prod.alertService}/editSubscription`,
  dashboardDetailsUrl: `${BASE_URL.prod.device}/getDashboardDetails`,
  alertActionUrl: `${BASE_URL.prod.alertService}/alertAction`,
  listFirmwaresUrl: `${BASE_URL.prod.device}/listFirmwares`,
  listIotAgentUrl: `${BASE_URL.prod.device}/listIotAgents`,
  uploadFirmwareUrl: `${BASE_URL.prod.device}/firmwareBlob`,
  deleteFirmwareBlobUrl: `${BASE_URL.prod.device}/deleteFirmwareBlob`,
  deleteIotAgentBlobUrl: `${BASE_URL.prod.device}/deleteIotAgentBlob`,
  uploadIotAgentUrl: `${BASE_URL.prod.device}/iotAgentBlob`,
  deviceLogUrl: `${BASE_URL.prod.device}/getDeviceLogs`,
  updateOrganizationExecutablesUrl: `${BASE_URL.prod.organization}/updateDeviceExecutables`,
  configureSinglewireTokenUrl: `${BASE_URL.prod.alertService}/configureSinglewireToken`,
  singlewireWebhookURL: `${BASE_URL.prod.alertService}/createSinglewireAlerts`,
  listSinglewireSiteUrl: `${BASE_URL.prod.alertService}/getSingleWireSites?`,
  mapSinglewireSitesUrl: `${BASE_URL.prod.alertService}/mapSinglewireSites?`,
  mapEverbridgeGroupsUrl: `${BASE_URL.prod.alertService}/mapEverbridgeGroups?`,
  configureEverbridgeTokenUrl: `${BASE_URL.prod.alertService}/configureEverbridgeToken`,
  listEverbridgeGroupUrl: `${BASE_URL.prod.alertService}/getEverbridgeGroups?`,
  getIntegrationWebhookStatusUrl: `${BASE_URL.prod.alertService}/getIntegrationWebhookStatus?`,
  everbridgeWebhookURL: `${BASE_URL.prod.alertService}/createEverbridgeAlerts`,
  alertusWebhookURL: `${BASE_URL.prod.alertService}/createAlertusAlert`,
  generateAlertusTokenUrl: `${BASE_URL.prod.organization}/generateAlertusToken`,
  listAlertusTokensUrl: `${BASE_URL.prod.organization}/listAlertusTokens`,
  revokeAlertusTokenUrl: `${BASE_URL.prod.organization}/revokeAlertusToken`,
  quickAlertsUrl: `${BASE_URL.prod.alertService}/quickAlerts`,
  listQuickAlertsUrl: `${BASE_URL.prod.alertService}/listQuickAlerts`,
  createQuickAlertsUrl: `${BASE_URL.prod.alertService}/createQuickAlerts`,
  editQuickAlertsUrl: `${BASE_URL.prod.alertService}/editQuickAlert`,
  deleteQuickAlertsUrl: `${BASE_URL.prod.alertService}/deleteQuickAlert`,
  sendQuickAlertsUrl: `${BASE_URL.prod.alertService}/sendQuickAlerts`,
  saveQuickAlertsOrderUrl: `${BASE_URL.prod.alertService}/saveQuickAlertsOrder`,
  approvePublicApiUserUrl: `${BASE_URL.prod.organization}/approvePublicApiUser`,
  createCapEndpointUrl: `${BASE_URL.prod.alertService}/createCapEndpoint`,
  listCapEndpointsUrl: `${BASE_URL.prod.alertService}/listCapEndpoints`,
  updateCapEndpointUrl: `${BASE_URL.prod.alertService}/updateCapEndpoint`,
  deleteCapEndpointUrl: `${BASE_URL.prod.alertService}/deleteCapEndpoint`,
  regenerateCapEndpointTokenUrl: `${BASE_URL.prod.alertService}/regenerateCapEndpointToken`,
  capWebhookURL: `${BASE_URL.prod.alertService}/cap/post?endpoint=`,
  rebootDeviceUrl: `${BASE_URL.prod.device}/rebootDevice`,
  getOrganizationsAnalyticsUrl: `${BASE_URL.prod.organization}/getOrganizationsAnalytics`,
  getSuperAdminDeviceAnalyticsUrl: `${BASE_URL.prod.device}/getSuperAdminDeviceAnalytics`,
  getThirdPartyIntegrationStatsUrl: `${BASE_URL.prod.alertService}/getThirdPartyIntegrationAdoptionStats`,
  getWebhookMigrationConfigUrl: `${BASE_URL.prod.alertService}/getWebhookMigrationConfig`,
  updateWebhookMigrationConfigUrl: `${BASE_URL.prod.alertService}/updateWebhookMigrationConfig`,
  triggerWebhookUrlUpdateReminderUrl: `${BASE_URL.prod.alertService}/triggerWebhookUrlUpdateReminder`,
  getAlertsStatsUrl: `${BASE_URL.prod.alertService}/getAlertsStats`,
  getVersionDistributionUrl: `${BASE_URL.prod.device}/getVersionDistribution`,
  getUserCountAndDetailsUrl: `${BASE_URL.prod.userService}/getUserCountAndDetails`,
  getAlertDetailsUrl: `${BASE_URL.prod.alertService}/getAlertDetails`,
  getHelpGuidesUrl: `${BASE_URL.prod.organization}/getHelpGuides`,
  addHelpGuideUrl: `${BASE_URL.prod.apimOrganizationUrl}/addHelpGuide`,
  editHelpGuideUrl: `${BASE_URL.prod.apimOrganizationUrl}/editHelpGuide`,
  deleteHelpGuideUrl: `${BASE_URL.prod.organization}/deleteHelpGuide`,
  firebaseConfig: {
    apiKey: "AIzaSyAF06wkkTO7pfmud6EeIwHPvCKYAEtFhwo",
    authDomain: "flashcast-prod.firebaseapp.com",
    projectId: "flashcast-prod",
    storageBucket: "flashcast-prod.firebasestorage.app",
    messagingSenderId: "409046822250",
    appId: "1:409046822250:web:6a46373fd98ba5ffcd4913",
  },
  roleIds: {
    superAdmin: 'ca310b8d-2f4a-44e0-a36e-957c202cd8d4',
    admin: 'c495eb57-eb18-489e-9802-62c474e5645c',
    operator: 'b4935647-30e4-4ed3-9074-dcac66c2f8ef',
    viewer: '84cc62c1-dabe-49d3-b16e-8b291232b285',
  },
  apimSubscriptionKey: '4c4790dceb9744ba8642d3b36f2f9e4a',
};

export const local = { ...LOCAL };
export const dev = { ...DEV };
export const prod = { ...PRODUCTION };

export const DEVICE_BASE = 'func-fuji-dev-cus-dvc';
export const DEVICE_BASE_URL = `https://${DEVICE_BASE}.azurewebsites.net/api`;
export const DELETE_ORGANIZATION_URL = '/deleteGroup';
export const LIST_DEVICES = '/listDevices';
export const ADD_DEVICE_URL = '/addDevice';
export const CREATE_GROUP_URL = '/creategroup';
export const EDIT_GROUP_URL = '/updategroup';
export const DELETE_DEVICE = DEVICE_BASE_URL + `/deleteDevice`;
export const UPDATE_DEVICE = DEVICE_BASE_URL + `/updateDevice`;
export const ASSIGN_DEVICES_URL = '/assignDevices';

export const ORGANIZATION_BASE_URL = `https://func-fuji-dev-cus-org.azurewebsites.net/api`;
export const SEND_EMAIL = ORGANIZATION_BASE_URL + `/sendEmail`;
export const VERIFY_EMAIL_ADDRESS =
  ORGANIZATION_BASE_URL + `/verifyEmailAddress`;
export const REGISTER_ORGANIZATION =
  ORGANIZATION_BASE_URL + `/registerOrganisation`;
export const LIST_ORGANIZATIONS = ORGANIZATION_BASE_URL + `/listorganisations`;

export const LIST_ALERTS = '/listAlerts';

export const USER_BASE_URL = `https://func-fuji-dev-cus-usr.azurewebsites.net/api`;
export const LIST_USERS = USER_BASE_URL + `/listUsers`;
export const DELETE_USER = USER_BASE_URL + `/deleteUser`;
export const UPDATE_USER = USER_BASE_URL + `/updateUser`;
export const CREATE_USER = USER_BASE_URL + `/createUser`;
